var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ui-select ng-model=\"vm.segment\" on-select=\"vm.goToSegment($select.selected)\" ng-required=\"true\" remove-selected=\"false\" class=\"c-select c-select--uiselect c-header-dropdown\"><ui-select-match placeholder=\"{{ 'select'|translate }}\"><segment-name segment=\"$select.selected\"></segment-name></ui-select-match><ui-select-choices repeat=\"option['name'] as option in vm.segments | filter: $select.search | limitTo: 30\"><segment-name segment=\"option\"></segment-name></ui-select-choices></ui-select>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/header/header-segments.jade
 ** module id = 582
 ** module chunks = 0
 **/